(() => {
  if (customElements.get("video-card")) return;

  class VideoCard extends HTMLElement {
    constructor() {
      super();

      this.playToggleEl = this.querySelector(".js-video-play-toggle");
      this.video = this.querySelector("video");
      this._listenersAttached = false;
    }

    connectedCallback() {
      this._attachEventListeners();
    }

    _attachEventListeners() {
      if (this._listenersAttached) return;
      this._listenersAttached = true;

      if (this.playToggleEl) {
        this.playToggleEl.addEventListener("click", this._handlePlayToggleClick.bind(this));
      }

      if (this.video) {
        this.video.addEventListener("play", () => this._setPlayingState(true));
        this.video.addEventListener("pause", () => this._handleVideoPause());
        this.video.addEventListener("ended", () => {
          this.video.currentTime = 0;
          this._setPlayingState(false);
        });
      }
    }

    _handleVideoPause() {
      if (!this.video || this.video.ended) {
        return;
      }

      this.video.setAttribute("controls", "");
    }

    _handlePlayToggleClick() {
      if (!this.video) {
        return;
      }

      if (this.video.paused || this.video.ended) {
        const playPromise = this.video.play();

        if (playPromise?.catch) {
          playPromise.catch(() => {});
        }
      } else {
        this.video.pause();
      }
    }

    _setPlayingState(isPlaying) {
      if (isPlaying) {
        this.video.setAttribute("controls", "");
      } else {
        this.video.removeAttribute("controls");
      }
      this.classList.toggle("playing", isPlaying);
    }
  }

  customElements.define("video-card", VideoCard);
})();
